import { useApplicationField } from '../useApplicationField';

// ─── eSign ────────────────────────────────────────────────────────────────────

export const useBorrowerEsignAcknowledgeFont = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.eSignFonts?.acknowledgeFont ?? null,
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: {
                    ...d.information?.borrower,
                    esign: {
                        ...(d.information?.borrower?.esign ?? {}),
                        eSignFonts: { ...(d.information?.borrower?.esign?.eSignFonts ?? {}), acknowledgeFont: v },
                    },
                },
            },
        })
    );

export const useBorrowerEsignTermSheetFont = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.eSignFonts?.termSheetFont ?? null,
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: {
                    ...d.information?.borrower,
                    esign: {
                        ...(d.information?.borrower?.esign ?? {}),
                        eSignFonts: { ...(d.information?.borrower?.esign?.eSignFonts ?? {}), termSheetFont: v },
                    },
                },
            },
        })
    );

export const useBorrowerEsignTypedName = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.typedName ?? '',
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: { ...d.information?.borrower, esign: { ...d.information?.borrower?.esign, typedName: v } },
            },
        })
    );

export const useBorrowerEsignTitle = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.title ?? '',
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: { ...d.information?.borrower, esign: { ...d.information?.borrower?.esign, title: v } },
            },
        })
    );

export const useBorrowerEsignDate = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.date ?? '',
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: { ...d.information?.borrower, esign: { ...d.information?.borrower?.esign, date: v } },
            },
        })
    );

export const useBorrowerEsignIpAddress = () =>
    useApplicationField(
        (d) => d.information?.borrower?.esign?.ipAddress ?? '',
        (d, v) => ({
            ...d,
            information: {
                ...d.information,
                borrower: { ...d.information?.borrower, esign: { ...d.information?.borrower?.esign, ipAddress: v } },
            },
        })
    );
